import { useTranslations } from 'contexts/Translation'
import PropTypes from 'prop-types'
import {
  Col,
  Container,
  Row,
  Card,
  Text,
  Divider,
  Title
} from '@qonsoll/react-design'
import { useHistory } from 'react-router-dom'
import { CardDropdown, SelectableCard } from 'components'
import { useSimpleFormActions } from 'hooks'
import { useParams } from 'react-router-dom'
import { updateParentHasManyRelationship } from 'hooks'

const RoleSimpleView = (props) => {
  const { role, onSelect, onDelete, index, isSelected, actions } = props

  // [ADDITIONAL_HOOKS]
  const { t } = useTranslations()
  const history = useHistory()
  const { handleDelete: removeDocument } = useSimpleFormActions({
    document: role,
    collectionName: 'roles'
  })
  const params = useParams()

  // [HANDLERS]
  const handleOpen = () => {
    history.push(`/roles/${role?._id}`)
  }
  const handleEdit = () => {
    history.push(`/roles/${role?._id}/edit`)
  }
  const handleDelete = (item, index) => {
    removeDocument()
    if (params.customerId)
      updateParentHasManyRelationship(
        params.customerId,
        'customers',
        'applicationIds',
        item?._id,
        true
      )
  }
  const handleSelect = (e) => {
    e.stopPropagation()
    onSelect?.(role?._id)
  }

  return (
    <CardDropdown
      onDelete={handleDelete}
      onEdit={handleEdit}
      onDoubleClick={handleOpen}
      onClick={handleSelect}
      document={role}
      index={index}
      {...actions}>
      <SelectableCard isSelected={isSelected}>
        <Row
          noGutters
          justifyContent="center"
          alignItems="center"
          py="4px"
          mb={2}>
          <Col>
            <Title
              level={4}
              overflow="hidden"
              textOverflow="ellipsis"
              maxWidth="250px"
              whiteSpace="nowrap">
              {role?.name}
            </Title>
          </Col>
        </Row>
      </SelectableCard>
    </CardDropdown>
  )
}

RoleSimpleView.propTypes = {
  role: PropTypes.object,
  onSelect: PropTypes.func,
  onDelete: PropTypes.func,
  index: PropTypes.number,
  isSelected: PropTypes.bool,
  actions: PropTypes.shape({
    onEdit: PropTypes.func,
    onDelete: PropTypes.func,
    onDoubleClick: PropTypes.func,
    onClick: PropTypes.func
  })
}

export default RoleSimpleView
